module.exports = [
  {
    title: 'ТО дизельной техники',
    info:
      'Наш сервис предлагает обслуживание вашего авто на регулярной основе. Меняйте фильтра, масло своевременно. Ведь это продлит срок службы вашего авто. После прохождения ТО делаем обнуление сервиса.',
    items: [
      {
        title: 'Замена фильтров',
        info:
          'Заблаговременно меняя фильтры вы оберегаете себя от дорогостоящего ремонта. Причины сменить топливный фильтр:',
        list: [
          'увеличился расход топлива',
          'уменьшилась мощность двигателя',
          'двигатель начинает троить',
          'двигатель глохнет на холостом ходу',
          'при повышении оборотов в работе двигателя происходят провалы'
        ]
      },
      {
        title: 'Замена масла',
        info:
          'Наличие масла на всех узлах гарантирует отсутствие трения и преждевременного износа деталей вашего автомобиля. Не упустите того момента когда масло закончится, ведь масло:',
        list: [
          'защищает двигатель от износа',
          'защищает детали от перегрева',
          'защищает поверхность металла от коррозии',
          'выводит твердые продукты сгорания топливно-воздушной смеси (нагар, сажа и др.)',
          'выводит продукты износа двигателя (металлическая стружка)'
        ]
      },
      {
        title: 'Замена свечей накала',
        info:
          'Меняем вышедшие из строя свечи накаливания. Симптомы нестабильной работы свечей накала на дизельном автомобиле:',
        list: [
          'затрудненный запуск двигателя',
          'наличие белого дыма из выхлопной трубы'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/to.js